import type { RouteObject } from 'react-router-dom';

/**
 * My account area. OWNED BY `m2-staff` (M2); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 */
export const accountRoutes: RouteObject[] = [
  {
    path: 'account',
    handle: { crumb: 'My account' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./AccountPage')).AccountPage }) },
      { path: 'change-password', handle: { crumb: 'Change password' }, lazy: async () => ({ Component: (await import('./ChangePasswordPage')).ChangePasswordPage }) },
    ],
  },
];
